// Copyright (c) Microsoft. All rights reserved.

import { ExtendedDetailsResponse } from '../../components/chat/chat-history/ChatDownloadReport';
import { BaseService } from './BaseService';

export class DocumentDownloadService extends BaseService {
    public downloadDocumentAsync = async (fileRelativePath: string, source: string, accessToken: string) => {
        return await this.getResponseAsync<Blob>(
            {
                commandPath: `download/${fileRelativePath}${source ? `?source=${source}` : ''}`,
                method: 'GET',
            },
            accessToken,
            undefined,
            'blob',
        );
    };

    public downloadExtendedDetailsDocumentAsync = async (
        query: string,
        useSemanticSearch: boolean,
        semanticConfigName: string,
        filter: string,
        accessToken: string,
    ) => {
        const exist = true;

        const body = {
            exist,
            query,
            useSemanticSearch,
            semanticConfigName,
            filter,
        };

        return await this.getResponseAsync<Blob>(
            {
                commandPath: `download/extendedDetails`,
                method: 'POST',
                body,
            },
            accessToken,
            undefined,
            'blob',
        );
    };

    public downloadExtendedDetailsDocumentAsStringAsync = async (
        query: string,
        useSemanticSearch: boolean,
        semanticConfigName: string,
        filter: string,
        IsDocumentIndex: boolean,
        accessToken: string,
    ) => {
        const exist = true;

        const body = {
            exist,
            query,
            useSemanticSearch,
            semanticConfigName,
            filter,
            IsDocumentIndex,
        };

        return await this.getResponseAsync<ExtendedDetailsResponse>(
            {
                commandPath: `download/extendedDetailsAsString`,
                method: 'POST',
                body,
            },
            accessToken,
        );
    };
}
